<template>
  <padder big>
    <div class="registrationContainer">
      <h2>{{ general.registration?.intro }}</h2>
      <CTAButton :text="general.registration?.button"/> 
      <replace-links
        :htmlContent="general.registration?.extra"
        class="extraInfo inlineText"
      />
    </div>
  </padder>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import ReplaceLinks from './ReplaceLinks.vue';
import CTAButton from './CTAButton.vue';

export default {
  components: { ReplaceLinks, CTAButton },
  methods: {
    ...mapActions(['register']),
  }
};
</script>

<style lang="scss" scoped>
.registrationContainer {
  margin-top: 224px;
  margin-bottom: 235px;
}

h2 {
  text-align: center;
  max-width: 1100px;
  margin: 0px auto;
}


.extraInfo {
  max-width: $reduced-width;
  margin: 0px auto;
  @include bigFontSize;
  text-align: center;
  font-weight: 500;
}

@media screen and (max-width: $breakpoint) {
  .registrationContainer {
    margin-top: 136px;
    margin-bottom: 166px;
  }

  a.registerLink {
    font-size: 30px;
    width: 310px;
  }

  .extraInfo {
    @include defaultFontSize;
  }
}
</style>
